import {
  AULA_DARK_ALERT_INFO_BG_COLOR,
  AULA_LIGHT_ALERT_INFO_BG_COLOR,
} from '@ublend-npm/aulaui-core';

const LIGHT_INFO_OUTLINED_COLOR = '#0088D1';
const DARK_INFO_OUTLINED_COLOR = '#2BB6F6';

export const createStyles = (theme: any) => {
  const isDark = theme.palette.mode === 'dark';
  const infoOutlinedColor = isDark
    ? DARK_INFO_OUTLINED_COLOR
    : LIGHT_INFO_OUTLINED_COLOR;

  return {
    infoButton: {
      color: theme.palette.text.secondary,
      '&:focus-visible': {
        outline: `2px solid ${theme.palette.primary.main}`,
        outlineOffset: 2,
      },
    },
    alertIcon: {
      width: 22,
      height: 22,
    },
    alert: {
      position: 'relative',
      mt: 2,
      alignItems: 'flex-start',
      borderRadius: 1,
      color: isDark ? '#B8E7FB' : '#014361',
      backgroundColor: isDark
        ? AULA_DARK_ALERT_INFO_BG_COLOR
        : AULA_LIGHT_ALERT_INFO_BG_COLOR,
      '& .MuiAlert-icon': {
        color: infoOutlinedColor,
        mt: '2px',
        opacity: 1,
      },
      '& .MuiAlert-message': {
        pr: 3,
      },
    },
    alertMessage: {
      color: 'inherit',
      lineHeight: 1.6,
    },
    alertCloseButton: {
      position: 'absolute',
      top: 8,
      right: 8,
      color: 'inherit',
      '&:focus-visible': {
        outline: `2px solid ${theme.palette.primary.main}`,
        outlineOffset: 2,
      },
    },
    modalContainer: {
      display: 'flex',
      flexDirection: 'column',
      overflowX: 'hidden',
      outline: 'none',
      boxSizing: 'border-box',
      width: { xs: '100%', sm: 'auto' },
      maxWidth: { xs: '100%', sm: 652 },
    },
    modalHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      p: 0,
      pb: 1,
      mr: -1,
    },
    modalContent: {
      p: 0,
      my: 1,
    },
    modalFooter: {
      p: 0,
      display: 'flex',
      justifyContent: 'end',
    },
  };
};
